import { PICKED_FILES_FROM } from "../../constants/UploadFilesConstants";
import { stopPropagationAndPreventEvent } from "../CommonModals/CommonUtils";

const OfflineSelectFiles = ({ dragChange, onFromCameraClickHandler, localisedValues }) => {
    const handleTakePhotoButton = (e) => {
        stopPropagationAndPreventEvent(e); // Prevent Extra clicks
        onFromCameraClickHandler();
    };

    return (
        <div className='drag-file-upload'>
            <div className='drag-file-upload-in'>
                <label className='drag-file-upload-label' onClick={onFromCameraClickHandler} htmlFor=''>
                    <div className='upload-icon'>
                        <span className='icon-upload-cloud'></span>
                    </div>
                    <div className='button-inline button-inline-tb-space d-flex justify-content-center'>
                        <div className='button'>
                            <button className='btn btn-primary btn-with-icon drag-upload-files-btn' onClick={(e) => handleTakePhotoButton(e)}>
                                <span className='btn-icon icon-camera'></span>
                                <span className='btn-text'>{localisedValues?.take_photo}</span>
                            </button>
                        </div>
                    </div>
                    <input
                        className='drag-file-upload-input'
                        id='cameraFileInput_selectFiles_for_offline_mode'
                        type='file'
                        accept='image/*'
                        capture='camera'
                        onChange={(e) => dragChange(e, PICKED_FILES_FROM.FROM_CAMERA)}
                        onClick={(e) => {
                            e.target.value = null;
                        }}
                    />
                </label>
            </div>
        </div>
    );
};

export default OfflineSelectFiles;
